module.exports = SportsbookMarketComponent;